<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Select a Firearm from the list" [matTooltipDisabled]="disabledTooltip(this.firearm)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.FirearmPool.firearm">Firearm</mat-label>
          <mat-select formControlName="firearm" id="firearm" (ngModelChange)="firearmChanging($event)"
            [(ngModel)]="item.firearm" (ngModelChange)="firearmChanged($event)" #firearm placeholder="Firearm"
            [compareWith]="firearmCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let firearm of firearmSelectionList" [value]="firearm">
              {{firearmDisplay(firearm)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Manager from the list" [matTooltipDisabled]="disabledTooltip(this.manager)"
          class="crud-item-input-wider">
          <mat-label i18n="@@type.FirearmPool.manager">Manager</mat-label>
          <mat-select formControlName="manager" id="manager" (ngModelChange)="managerChanging($event)"
            [(ngModel)]="item.manager" (ngModelChange)="managerChanged($event)" #manager placeholder="Manager"
            [compareWith]="managerCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let manager of managerSelectionList" [value]="manager">
              {{managerDisplay(manager)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Status from the list" [matTooltipDisabled]="disabledTooltip(this.status)">
          <mat-label i18n="@@type.FirearmPool.status">Status</mat-label>
          <mat-select formControlName="status" id="status" (ngModelChange)="statusChanging($event)"
            [(ngModel)]="item.status" (ngModelChange)="statusChanged($event)" #status placeholder="Status">
            <mat-option *ngFor="let status of statusSelectionList" [value]="status.code">
              {{status.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.FirearmPool.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdBy" (ngModelChange)="createdByChanging($event)"
            [(ngModel)]="item.createdBy" (ngModelChange)="createdByChanged($event)" #createdBy maxlength="255"
            placeholder="Created By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Created Date" [matTooltipDisabled]="disabledTooltip(this.createdDate)">
          <mat-label i18n="@@type.FirearmPool.createdDate">Created Date</mat-label>
          <input matInput formControlName="createdDate" id="createdDate" (ngModelChange)="createdDateChanging($event)"
            [(ngModel)]="item.createdDate" (ngModelChange)="createdDateChanged($event)" #createdDate
            [matDatepicker]="createdDateDatePicker" placeholder="Created Date">
          <mat-datepicker-toggle matSuffix [for]="createdDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>


      <span>
        <mat-form-field matTooltip="Updated By" [matTooltipDisabled]="disabledTooltip(this.updatedBy)">
          <mat-label i18n="@@type.FirearmPool.updatedBy">Updated By</mat-label>
          <input matInput formControlName="updatedBy" id="updatedBy" (ngModelChange)="updatedByChanging($event)"
            [(ngModel)]="item.updatedBy" (ngModelChange)="updatedByChanged($event)" #updatedBy maxlength="255"
            placeholder="Updated By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Updated Date" [matTooltipDisabled]="disabledTooltip(this.updatedDate)">
          <mat-label i18n="@@type.FirearmPool.updatedDate">Updated Date</mat-label>
          <input matInput formControlName="updatedDate" id="updatedDate" (ngModelChange)="updatedDateChanging($event)"
            [(ngModel)]="item.updatedDate" (ngModelChange)="updatedDateChanged($event)" #updatedDate
            [matDatepicker]="updatedDateDatePicker" placeholder="Updated Date">
          <mat-datepicker-toggle matSuffix [for]="updatedDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>
    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <h2>Members</h2>
      <app-ranger-list [items]="item.members" [showCreate]="false" [showDelete]="false" [showEdit]="false"
        [showView]="false" [actions]="memberActions"></app-ranger-list>
    </div>

    <div class="crud-item-section" *ngIf="allowsAddMember()">

      <span>
        <mat-form-field matTooltip="Select a Member from the list" [matTooltipDisabled]="disabledTooltip(this.member)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.FirearmPool.member">Add a Member</mat-label>
          <input matInput [matAutocomplete]="memberAutocomplete" formControlName="member" id="member"
            (ngModelChange)="memberChanging($event)" [(ngModel)]="memberToAdd" (ngModelChange)="memberChanged($event)"
            #member>
          <mat-autocomplete id="memberAutocomplete" #memberAutocomplete [displayWith]="memberDisplay">
            <mat-option *ngFor="let member of memberSelectionList | async" [value]="member">
              {{memberDisplay(member)}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </span>


      <button class="action-button" mat-raised-button color="accent2" (click)="addMember()" i18n="@@actions.addMember"
        id="actions.addMember" [disabled]="!addMemberEnabled()">Add Member</button>

      <button class="action-button" mat-raised-button color="primary" (click)="addAllBusinessUnitMembers()"
        i18n="@@actions.addAllBusinessUnitMembers" id="actions.addAllBusinessUnitMembers">Add All BU Rangers as
        Members</button>

      <button class="action-button" mat-raised-button color="accent2" (click)="clearMembers()"
        i18n="@@actions.clearMembers" id="actions.clearMembers" [disabled]="!isClearMembersEnabled()">Remove all Members</button>
    </div>

  </form>
</div>